import React from 'react'

const CallHistoryTab = () => {
  return (
    <div>
      Call History Tab Content
    </div>
  )
}

export default CallHistoryTab